import { useRef, useState } from 'react';
import styled from 'styled-components';
import { Input, TextFieldInput } from '../../inputs';
import { ModelInputProps } from '../Input';
import { FormInput, useModelForm } from '../ModelForm';
import { Flex } from '../../../Flex';
import { useIsAutoSave } from '../AutoSave';
import { useFormConfigurationContext } from '../../../../..';

const Container = styled(Flex)`${({ theme }) => `
  gap: ${theme.padding[2]};
  width: 40%;
`}`;

export function ModelSortCode(props: ModelInputProps) {
  const {
    id = '',
    field,
    valueOverride,
    errorOverride,
    onBlur = () => {},
    disabled,
  } = props;

  const { isDisabled } = useFormConfigurationContext(disabled);

  const {
    errors,
    warnings,
    value,
    update,
  } = useModelForm(field, valueOverride, errorOverride);

  const [sortCodeParts, setSortCodeParts] = useState<string[]>([
    value?.slice(0, 2) ?? '',
    value?.slice(2, 4) ?? '',
    value?.slice(4, 6) ?? '',
  ]);

  const { isAutoSave } = useIsAutoSave();

  const changed = useRef<boolean>(false);

  const onChangeSortCodePart = (partNum: number, newValue: string) => {
    const formattedValue = newValue.replace(/[^0-9]+/g, '');

    if (formattedValue.length < 3) {
      const newSortCodeParts = [
        partNum === 0 ? formattedValue : sortCodeParts[0],
        partNum === 1 ? formattedValue : sortCodeParts[1],
        partNum === 2 ? formattedValue : sortCodeParts[2],
      ];

      setSortCodeParts(newSortCodeParts);
      changed.current = true;
    }
  };

  const [touched, setTouched] = useState<boolean>(false);

  const blur = (targetValue: string) => {
    setTouched(true);
    onBlur(targetValue);
    if (changed.current && isAutoSave) {
      update({ [field]: `${sortCodeParts[0]}${sortCodeParts[1]}${sortCodeParts[2]}` });
    }
    changed.current = false;
  };

  const hasError = !!errors?.length && touched;

  return (
    <FormInput>
      <Input id={id} hasError={hasError} errors={errors} warnings={warnings} {...props}>
        <Container>
          <TextFieldInput
            id={`${id}-one`}
            styles=""
            hasError={hasError}
            value={sortCodeParts[0]}
            onChange={(e) => onChangeSortCodePart(0, e.target.value)}
            onBlur={(e) => blur(e.target.value)}
            disabled={isDisabled}
          />
          <TextFieldInput
            id={`${id}-two`}
            styles=""
            hasError={hasError}
            value={sortCodeParts[1]}
            onChange={(e) => onChangeSortCodePart(1, e.target.value)}
            onBlur={(e) => blur(e.target.value)}
            disabled={isDisabled}
          />
          <TextFieldInput
            id={`${id}-three`}
            styles=""
            hasError={hasError}
            value={sortCodeParts[2]}
            onChange={(e) => onChangeSortCodePart(2, e.target.value)}
            onBlur={(e) => blur(e.target.value)}
            disabled={isDisabled}
          />
        </Container>
      </Input>
    </FormInput>
  );
}
